module.exports = __webpack_public_path__ + "bb4.no2.2fca6e6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb4.no2.jpg
// module id = KOz/
// module chunks = 0